export default __webpack_public_path__ + "static/process-improvement-cut-waste-and-improve-business-efficiency-9a480f2b22ef5b978066c70ec43c51fa.pdf";